import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { financialInsightsService } from '../../services/financial-insights.service';

// ---- Content Hooks ----
export const useFinancialContents = (params = {}) => {
  return useQuery({
    queryKey: ['financialContents', params],
    queryFn: () => financialInsightsService.getContents(params),
  });
};

export const useFinancialContentById = (id) => {
  return useQuery({
    queryKey: ['financialContent', id],
    queryFn: () => financialInsightsService.getContentById(id),
    enabled: !!id,
  });
};

export const useFinancialContentBySlug = (slug) => {
  return useQuery({
    queryKey: ['financialContentSlug', slug],
    queryFn: () => financialInsightsService.getContentBySlug(slug),
    enabled: !!slug,
  });
};

// ---- Categories Hooks ----
export const useFinancialCategories = () => {
  return useQuery({
    queryKey: ['financialCategories'],
    queryFn: financialInsightsService.getContentCategories,
  });
};

export const useFinancialCategoryById = (id) => {
  return useQuery({
    queryKey: ['financialCategory', id],
    queryFn: () => financialInsightsService.getContentCategoryById(id),
    enabled: !!id,
  });
};

// ---- Bookmark Hooks ----
export const useBookmarks = () => {
  return useQuery({
    queryKey: ['bookmarks'],
    queryFn: financialInsightsService.getBookmarks,
  });
};

export const useBookmarkContent = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ contentId }) => financialInsightsService.bookmarkContent(contentId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['bookmarks'] }),
  });
};

export const useDeleteBookmark = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id }) => financialInsightsService.deleteBookmark(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['bookmarks'] }),
  });
};

export const useClearBookmarks = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => financialInsightsService.clearBookmarks(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['bookmarks'] }),
  });
};